import type { HTMLAttributes } from 'react';
import { cn } from '../utils/cn.js';

/**
 * Ruled paper page wrapper — red margin rule + faint blue ruling.
 * Used for landing, auth, pricing, error pages (public shell).
 */
export function RuledPage({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('ruled', className)} {...rest}>
      {children}
    </div>
  );
}
